import { makeActionCreator } from '../../utils';
import { validationActionTypes } from '../actionTypes';

// VALIDATION ACTION CREATORS

/**
 * Create an action creator that sets the state value of the validation errors
 * Used for updating state at validation
 * @constant
 * @type {function} updateValidationErrors action creator
 */
export const updateValidationErrors = makeActionCreator(validationActionTypes.UPDATE_VALIDATION_ERRORS, 'errors');



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/actions/actionCreators/validationActionCreators.js